// ** React Imports
import { Fragment, useState } from "react";

// ** MUI Components
import {
  IconButton,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";

// Custom Component Imports
import CustomTextField from '../../../components/mui/text-field';

// ** Icon Imports
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from '../../../components/icon'
import InfoIcon from '@mui/icons-material/Info';
import { DeactivatePortal, ReactivatePortal } from "screens/Auth/invite/logic/InviteHandler";

const DeactivateEmployee = ({
    open,
    handleClose,
    employeeID,
    email,
    toast,
    loadStatuses,
    portalMode
}) => {

  const DeactivateOrActivate = async () => {

    const res = portalMode === "Deactivate" ? 
      await DeactivatePortal(employeeID) :
      await ReactivatePortal(employeeID);    

    if(res.statusCode==="OK" && !res.isError){
      toast.success(`Employee portal ${portalMode === "Deactivate" ? "deactivated" : "reactivated"}  successfully!`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      handleClose();
      loadStatuses();
    } else {
      toast.error(res?.message || `Something went wrong. Please try again!`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      handleClose();
      loadStatuses();
    }
  }

    return (
        <Dialog
        PaperProps={{
    sx: {
      width: '500px',
    }
  }}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="h4">
                        {portalMode === "Deactivate" ? "Deactivated" : "Reactivate"} Employee Portal?
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Are you sure you wish to {portalMode === "Deactivate" ? "deactivate" : "reactivate"} the employee portal for{' '}
                        <Typography
                          component="span"
                          sx={{ fontWeight: 600, color: 'text.secondary' }}
                        >
                          {email}
                        </Typography>
                        ?
                      </Typography>

                    </Box>
                </Grid>
                <Grid item xs={12} mb={4}>
                   <Box
                      sx={{
                        backgroundColor: 'rgba(216, 0, 39, 0.05)', // 5% opacity
                        p: 4,
                        borderRadius: 2
                      }}
                    >
                        <Box sx={{display: 'flex', mb: 2, gap: 2}}>
                            <InfoIcon sx={{color: '#D80027'}} />
                            <Typography variant='h5'>Important Note</Typography>
                        </Box>
                        <Typography variant="body" color='text.secondary'>
                          {portalMode === "Deactivate" ? 
                            "Deactivating the portal will stop employee access to self-service features like viewing history and tracking status." 
                            : "You will be billed $20 monthly for this User.  If they log in for less than 5 minutes (seasonal or vacation), you will not be billed."}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions
          sx={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                padding: '20px 24px !important', 
                boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                zIndex: 1 
            }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button
              variant="outlined"
            //   color="info"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              color={portalMode === "Deactivate" ? "error" : "main"}
              onClick={DeactivateOrActivate}
            >
                Confirm {portalMode === "Deactivate" ? "Deactivation" : "Reactivation"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    )
}

export default DeactivateEmployee